
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[park]/diem-den",
      function () {
        return require("private-next-pages/[park]/diem-den/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[park]/diem-den"])
      });
    }
  